import { useTranslation } from "react-i18next";
import { sendMessage } from "utils/webview";
import useIsInappWebview from "hooks/useIsInappWebview";
import { useState } from "react";
import CustomModal from "./CustomModal";
import { Button } from "@mui/joy";

export default function RequestStoreReviewButton({
  disabled,
}: {
  disabled: boolean;
}) {
  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });

  const isInappWebview = useIsInappWebview();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        disabled={disabled}
        variant="Solid"
        onClick={(e) => {
          e.stopPropagation();
          if (isInappWebview) {
            sendMessage(
              JSON.stringify({
                event: "open_review",
              })
            );
          } else {
            setIsOpen(true);
          }
        }}
      >
        {t_ui("리뷰 남기기")}
      </Button>
      <CustomModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title={"모바일 기기에서 진행해주세요"}
        subtitle={""}
        actions={[
          {
            label: "확인",
            variant: "Solid",
            onClick: () => setIsOpen(false),
          },
        ]}
      />
    </>
  );
}
